import React, { useState } from 'react';
import './Page.css';

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState('Data Analytics');
  const blogCategories = [
    { name: 'Data Analytics' },
    { name: 'Data Engineering' },
    { name: 'Data Science & AI' },
    { name: 'Career Guidance' }
  ];

  const blogPosts = [
    {
      id: 1,
      title: 'How to Start a Career in Data Analytics in India',
      category: 'Data Analytics',
      excerpt: 'Learn how to start a career in Data Analytics in India. Step by step roadmap, required skills, tools, projects, and job tips for freshers and career switchers.',
      content: `
        <div class="blog-full-post">
          <p>Data is driving decisions in almost every industry today. From e-commerce and banking to healthcare and startups, companies rely on data to grow. This has made Data Analytics one of the most in-demand career options in India.</p>
          
          <p>If you are a student, fresher, or working professional wondering how to enter this field, this guide will give you a clear roadmap to start your career in Data Analytics in India.</p>
          
          <h3>What is Data Analytics?</h3>
          <p>Data Analytics is the process of collecting, cleaning, analyzing, and interpreting data to help businesses make better decisions.</p>
          
          <p>A Data Analyst transforms raw data into useful insights. These insights help companies understand customer behavior, improve performance, reduce costs, and increase profits.</p>
          
          <p>In simple terms, data analysts answer questions like:</p>
          <ul>
            <li>Why are sales dropping in a region?</li>
            <li>Which product is performing the best?</li>
            <li>What type of customers bring the most revenue?</li>
          </ul>
          
          <h3>Why Choose a Career in Data Analytics in India?</h3>
          <p>The demand for skilled data professionals is growing rapidly across India. Here is why this field is a great career choice:</p>
          <ul>
            <li><strong>High demand across industries</strong></li>
            <li><strong>Good starting salaries for freshers</strong></li>
            <li><strong>Opportunities in tech, finance, retail, healthcare, and more</strong></li>
            <li><strong>Career growth into Data Scientist and Data Engineer roles</strong></li>
            <li><strong>Options to work with Indian and global companies</strong></li>
          </ul>
          <p>For many learners, Data Analytics is the best entry point into the data and AI field.</p>
          
          <h3>Skills Required to Become a Data Analyst</h3>
          <p>You do not need to be an expert programmer to start. You need the right mix of tools and problem-solving skills.</p>
          
          <p><strong>1. Excel for Data Analysis</strong> - Excel is widely used for basic data analysis. You should know formulas, pivot tables, charts, and data cleaning.</p>
          
          <p><strong>2. SQL</strong> - SQL is used to work with databases. Almost every company uses databases, so SQL is one of the most important Data Analyst skills.</p>
          
          <p><strong>3. Data Visualization Tools</strong> - Tools like Power BI and Tableau help you create dashboards and reports. These tools make data easy to understand for decision makers.</p>
          
          <p><strong>4. Basic Statistics</strong> - Understanding averages, percentages, and trends helps you analyze data accurately.</p>
          
          <p><strong>5. Analytical Thinking</strong> - Companies hire Data Analysts to solve problems. Logical thinking and curiosity are key.</p>
          
          <h3>Step by Step Roadmap to Start a Career in Data Analytics</h3>
          <p>If you are serious about becoming a Data Analyst in India, follow this structured path:</p>
          
          <p><strong>Step 1: Learn Data Basics and Excel</strong> - Start with understanding how data is organized. Learn Excel for sorting, filtering, and analyzing data.</p>
          
          <p><strong>Step 2: Master SQL</strong> - Practice writing SQL queries to extract and analyze data. Focus on SELECT, JOIN, GROUP BY, and filtering.</p>
          
          <p><strong>Step 3: Learn Power BI or Tableau</strong> - Choose one visualization tool and learn how to build dashboards. Companies value candidates who can present insights visually.</p>
          
          <p><strong>Step 4: Work on Real Data Analytics Projects</strong> - Projects are what make your resume strong. Some beginner friendly project ideas:</p>
          <ul>
            <li>Sales performance dashboard</li>
            <li>Customer segmentation analysis</li>
            <li>Product trend analysis</li>
            <li>Website traffic analysis</li>
          </ul>
          <p>Projects prove that you can apply your Data Analytics skills in real scenarios.</p>
          
          <p><strong>Step 5: Build a Portfolio and Resume</strong> - Create a portfolio with your dashboards and project case studies. Highlight tools like Excel, SQL, and Power BI in your resume.</p>
          
          <p><strong>Step 6: Prepare for Data Analyst Interviews</strong> - Practice common Data Analyst interview questions, SQL queries, and case studies. Communication skills are also important because you will explain insights to business teams.</p>
          
          <h3>Who Can Start a Career in Data Analytics?</h3>
          <p>One of the best things about Data Analytics is that people from different backgrounds can enter this field:</p>
          <ul>
            <li>Engineering students</li>
            <li>Commerce and business graduates</li>
            <li>Arts and science students</li>
            <li>Working professionals from non-technical roles</li>
            <li>Freshers looking for job-oriented skills</li>
          </ul>
          <p>With proper training and hands-on practice, anyone can build a career in Data Analytics.</p>
          
          <h3>Common Mistakes to Avoid</h3>
          <p>Many beginners make these mistakes while learning Data Analytics:</p>
          <ul>
            <li>Learning only theory without doing projects</li>
            <li>Ignoring SQL and focusing only on tools</li>
            <li>Not creating a portfolio</li>
            <li>Applying for jobs without interview preparation</li>
            <li>Jumping between courses without mastering basics</li>
          </ul>
          <p>Consistency and practice are more important than rushing.</p>
          
          <h3>Final Thoughts</h3>
          <p>A career in Data Analytics in India offers strong growth, good salaries, and long-term opportunities. The key is to learn the right tools, work on real projects, and follow a structured roadmap.</p>
          
          <p>If you stay consistent and keep improving your skills, you can confidently start your journey into the data field and build a successful career as a Data Analyst.</p>
        </div>
      `,
      metaTitle: 'How to Start a Career in Data Analytics in India | Beginner Guide',
      metaDescription: 'Learn how to start a career in Data Analytics in India. Step by step roadmap, required skills, tools, projects, and job tips for freshers and career switchers.',
      keywords: ['Career in Data Analytics in India', 'Data Analyst skills', 'Data Analytics roadmap', 'Data Analyst jobs for freshers', 'how to become a Data Analyst']
    },
    {
      id: 2,
      title: 'Data Engineering Roadmap for Beginners',
      category: 'Data Engineering',
      excerpt: 'A comprehensive guide to starting your career in Data Engineering with essential skills and tools you need to learn.',
      content: `
        <div class="blog-full-post">
          <p>Data Engineering is the backbone of modern data infrastructure. While Data Scientists and Analysts work with data, Data Engineers build the systems that collect, store, and process data at scale.</p>
          
          <h3>What is Data Engineering?</h3>
          <p>Data Engineering is the practice of designing, building, and maintaining systems that collect, process, and store data. Data Engineers create data pipelines that move data from sources to data warehouses where analysts and scientists can use it.</p>
          
          <h3>Why Choose Data Engineering?</h3>
          <ul>
            <li>High demand globally with excellent salaries</li>
            <li>Work on large-scale data systems</li>
            <li>Career progression to Senior Engineer and Architect roles</li>
            <li>Opportunities across tech, finance, healthcare, and e-commerce</li>
            <li>Continuous learning with new tools and technologies</li>
          </ul>
          
          <h3>Core Skills for Data Engineers</h3>
          <p><strong>1. Programming Languages</strong> - Python and Scala are most commonly used. Java is also important for big data frameworks.</p>
          
          <p><strong>2. SQL and Databases</strong> - Strong SQL knowledge and understanding of relational and NoSQL databases like MongoDB, Cassandra.</p>
          
          <p><strong>3. Big Data Tools</strong> - Apache Spark, Hadoop, and Kafka are essential tools for processing large volumes of data.</p>
          
          <p><strong>4. Cloud Platforms</strong> - AWS, Google Cloud, and Azure experience is highly valuable.</p>
          
          <p><strong>5. Data Warehousing</strong> - Knowledge of Snowflake, BigQuery, and Redshift.</p>
          
          <h3>Learning Roadmap</h3>
          <p><strong>Phase 1: Fundamentals</strong> - Start with core programming and SQL. Master databases and data structures.</p>
          
          <p><strong>Phase 2: Big Data</strong> - Learn Apache Spark, Hadoop, and distributed systems concepts.</p>
          
          <p><strong>Phase 3: Cloud & Tools</strong> - Get certified in cloud platforms and learn modern data engineering tools.</p>
          
          <p><strong>Phase 4: Real Projects</strong> - Build end-to-end data pipelines and contribute to open-source projects.</p>
          
          <h3>Future of Data Engineering</h3>
          <p>As organizations collect more data, the need for skilled Data Engineers will continue to grow. Focus on staying updated with emerging technologies and best practices.</p>
        </div>
      `,
      metaTitle: 'Data Engineering Roadmap for Beginners | Complete Guide',
      metaDescription: 'Learn the complete roadmap to start your career in Data Engineering with essential skills and tools.',
      keywords: ['Data Engineer skills', 'Data Engineering roadmap', 'Big Data tools', 'Apache Spark']
    },
    {
      id: 3,
      title: 'Data Science vs Data Analytics: Which Career Path is Right for You?',
      category: 'Data Science & AI',
      excerpt: 'Understand the key differences between Data Science and Data Analytics roles, skills required, and which path suits your career goals.',
      content: `
        <div class="blog-full-post">
          <p>Both Data Science and Data Analytics are in-demand careers in the data field, but they involve different skill sets and responsibilities. Let's understand the differences to help you choose the right path.</p>
          
          <h3>What is Data Science?</h3>
          <p>Data Science is a multidisciplinary field that combines statistics, programming, machine learning, and domain knowledge to extract insights and build predictive models.</p>
          
          <p>Data Scientists work on complex problems like building recommendation engines, predicting customer churn, detecting fraud, and optimizing business processes.</p>
          
          <h3>What is Data Analytics?</h3>
          <p>Data Analytics focuses on analyzing historical data to understand what happened and why. Analysts use tools like Excel, SQL, and visualization platforms to create reports and dashboards.</p>
          
          <h3>Key Differences</h3>
          <p><strong>Focus</strong> - Data Analysts answer "What happened?" while Data Scientists answer "What will happen?"</p>
          
          <p><strong>Tools</strong> - Analysts use Excel, SQL, Power BI, Tableau. Scientists use Python, R, machine learning frameworks.</p>
          
          <p><strong>Math & Statistics</strong> - Analytics needs basic statistics. Data Science requires deep knowledge of statistics and machine learning algorithms.</p>
          
          <p><strong>Time to Productivity</strong> - You can become job-ready in Data Analytics within 3-6 months. Data Science typically requires 1-2 years of focused learning.</p>
          
          <h3>Skills Comparison</h3>
          <ul>
            <li><strong>Data Analyst</strong> - Excel, SQL, Power BI/Tableau, basic statistics, business acumen</li>
            <li><strong>Data Scientist</strong> - Python/R, machine learning, advanced statistics, SQL, domain expertise</li>
          </ul>
          
          <h3>Which Path to Choose?</h3>
          <p>Choose Data Analytics if you prefer working with business teams and creating visual insights. Choose Data Science if you enjoy programming and building mathematical models.</p>
          
          <h3>Career Growth</h3>
          <p>Many professionals start with Data Analytics and transition to Data Science. This gives you time to build strong fundamentals while earning.</p>
        </div>
      `,
      metaTitle: 'Data Science vs Data Analytics | Career Comparison Guide',
      metaDescription: 'Understand the differences between Data Science and Data Analytics to choose the right career path for you.',
      keywords: ['Data Science vs Analytics', 'Data Science career', 'Data Analytics career', 'Career comparison']
    },
    {
      id: 4,
      title: 'Best Data Skills to Learn in 2026',
      category: 'Career Guidance',
      excerpt: 'Discover the most in-demand data skills that will boost your career prospects in 2026 and beyond.',
      content: `
        <div class="blog-full-post">
          <p>The data field is evolving rapidly with new tools and technologies emerging every year. Here are the most in-demand data skills for 2026 that will enhance your career prospects.</p>
          
          <h3>Top Technical Skills for 2026</h3>
          <p><strong>1. Python & SQL</strong> - Still the most important languages. Python for data science and SQL for databases.</p>
          
          <p><strong>2. Machine Learning & AI</strong> - Understanding ML models, neural networks, and AI applications is increasingly important.</p>
          
          <p><strong>3. Cloud Platforms</strong> - AWS, Google Cloud, and Azure experience is essential. Most companies are moving to the cloud.</p>
          
          <p><strong>4. Data Visualization</strong> - Advanced dashboarding with Power BI, Tableau, and modern tools like Looker.</p>
          
          <p><strong>5. Big Data Technologies</strong> - Spark, Hadoop, and stream processing with Kafka.</p>
          
          <p><strong>6. Data Engineering</strong> - Building ETL pipelines and data warehouses is highly valued.</p>
          
          <h3>Soft Skills That Matter</h3>
          <ul>
            <li>Communication and storytelling with data</li>
            <li>Business acumen and domain knowledge</li>
            <li>Problem-solving and critical thinking</li>
            <li>Project management and collaboration</li>
            <li>Adaptability to learn new tools quickly</li>
          </ul>
          
          <h3>Emerging Technologies to Watch</h3>
          <p><strong>GenAI and LLMs</strong> - Large Language Models are transforming how we work with data. Understanding AI applications is becoming essential.</p>
          
          <p><strong>Data Privacy & Security</strong> - With stricter regulations, knowledge of data security and compliance is valuable.</p>
          
          <p><strong>Real-time Analytics</strong> - Companies increasingly need real-time insights, making stream processing skills valuable.</p>
          
          <h3>How to Stay Ahead</h3>
          <ul>
            <li>Take up certifications in cloud platforms</li>
            <li>Build projects using latest tools</li>
            <li>Follow industry trends and research</li>
            <li>Contribute to open-source projects</li>
            <li>Network with industry professionals</li>
          </ul>
          
          <h3>Conclusion</h3>
          <p>The data field offers tremendous opportunities for those who stay updated with technology. Focus on fundamentals first, then gradually learn new tools as they become relevant to your career.</p>
        </div>
      `,
      metaTitle: 'Best Data Skills to Learn in 2026 | Career Guide',
      metaDescription: 'Learn the most in-demand data skills for 2026 and boost your career prospects in the data field.',
      keywords: ['Data skills 2026', 'In-demand skills', 'Data career', 'Machine learning skills']
    },
    {
      id: 5,
      title: 'Data Career Opportunities in Bhubaneswar',
      category: 'Career Guidance',
      excerpt: 'Explore growing data career opportunities in Bhubaneswar and why it\'s becoming a tech hub for data professionals.',
      content: `
        <div class="blog-full-post">
          <p>Bhubaneswar is emerging as a significant tech hub in India with growing opportunities for data professionals. From startups to established tech companies, the city is creating exciting career prospects for data analysts, engineers, and scientists.</p>
          
          <h3>Why Bhubaneswar for Data Careers?</h3>
          <p><strong>Growing Tech Ecosystem</strong> - The city has a rapidly expanding IT sector with companies setting up development centers and innovation hubs.</p>
          
          <p><strong>Lower Cost of Living</strong> - Compared to metros like Bangalore and Mumbai, Bhubaneswar offers a better work-life balance with lower expenses.</p>
          
          <p><strong>Emerging Startups</strong> - Many startups are finding Bhubaneswar attractive, creating exciting opportunities for professionals.</p>
          
          <p><strong>Government Support</strong> - The state government is promoting IT and tech industries through various initiatives.</p>
          
          <h3>Top Companies Hiring in Bhubaneswar</h3>
          <ul>
            <li>TCS (Tata Consultancy Services)</li>
            <li>Tech Mahindra</li>
            <li>Infosys</li>
            <li>Various fast-growing startups</li>
            <li>Local and national e-commerce companies</li>
          </ul>
          
          <h3>Data Career Roles Available</h3>
          <p><strong>Data Analysts</strong> - Companies need analysts to process business data and create insights.</p>
          
          <p><strong>Data Engineers</strong> - Growing demand for engineers to build data infrastructure.</p>
          
          <p><strong>Business Analysts</strong> - Roles combining data analysis with business understanding.</p>
          
          <h3>Salary Expectations</h3>
          <p>While salaries in Bhubaneswar are generally lower than metro cities, they are competitive and the cost of living is significantly lower, giving you better purchasing power.</p>
          
          <h3>Getting Started</h3>
          <p>Build a strong portfolio of projects, get certified in relevant tools, and network with local tech communities. Attending tech meetups and conferences in Bhubaneswar is a great way to connect with companies and professionals.</p>
          
          <h3>Future Outlook</h3>
          <p>As Bhubaneswar continues to develop as a tech hub, opportunities for data professionals will only increase. Now is a great time to establish your career in the city.</p>
        </div>
      `,
      metaTitle: 'Data Career Opportunities in Bhubaneswar | 2026 Guide',
      metaDescription: 'Explore growing data career opportunities in Bhubaneswar and why it\'s becoming a tech hub for data professionals.',
      keywords: ['Bhubaneswar data jobs', 'Data careers', 'Tech hub', 'Job opportunities']
    }
  ];

  return (
    <div className="page">
      <section className="page-hero page-hero--red">
        <div className="container">
          <h1>Data Career Tips and Industry Insights</h1>
          <p className="hero-subtitle">Learn from industry experts and stay updated with the latest trends in data careers</p>
        </div>
      </section>

      <section className="page-content section">
        <div className="container">
          <div className="blog-categories">
            <h2>Browse by Category</h2>
            <div className="category-buttons">
              {blogCategories.map((category, index) => (
                <button 
                  key={index} 
                  className={`category-btn ${selectedCategory === category.name ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(category.name)}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>

          <div className="blog-featured">
            {blogPosts.filter(post => post.category === selectedCategory).map((post) => (
              <div key={post.id} className="blog-featured-post">
                <div className="blog-category-badge">{post.category}</div>
                <h1>{post.title}</h1>
                <p className="blog-excerpt">{post.excerpt}</p>
                <div 
                  className="blog-content"
                  dangerouslySetInnerHTML={{ __html: post.content }}
                />
              </div>
            ))}
          </div>


        </div>
      </section>
    </div>
  );
};

export default Blog;



